import type { ShareType } from "../../common/types";
import { Button, Typography, darken } from "@mui/material";
import { memberTheme } from "@flow/frontend/member/memberTheme";

function ShareIcon() {
  return (
    <svg
      enableBackground="new 0 0 64 64"
      height="32px"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 64 64"
      width="32px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M32,7.173c-13.689,0-24.826,11.137-24.826,24.826c0,13.69,11.137,24.828,24.826,24.828s24.826-11.138,24.826-24.828  C56.826,18.31,45.689,7.173,32,7.173z M25.484,31.956c0,0.25-0.025,0.494-0.061,0.734l10.447,5.115  c0.894-0.94,2.154-1.529,3.554-1.529c2.711,0,4.908,2.197,4.908,4.908s-2.197,4.908-4.908,4.908s-4.908-2.197-4.908-4.908  c0-0.25,0.025-0.494,0.061-0.734L24.13,35.335c-0.894,0.94-2.154,1.529-3.554,1.529c-2.711,0-4.908-2.197-4.908-4.908  s2.197-4.908,4.908-4.908c1.406,0,2.671,0.595,3.566,1.542l10.432-5.059c-0.034-0.234-0.058-0.472-0.058-0.716  c0-2.711,2.197-4.908,4.908-4.908s4.908,2.197,4.908,4.908s-2.197,4.908-4.908,4.908c-1.406,0-2.671-0.595-3.566-1.542L25.426,31.24  C25.461,31.475,25.484,31.712,25.484,31.956z" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.25 0H3.75C1.67893 0 0 1.67893 0 3.75V20.25C0 22.3211 1.67893 24 3.75 24H20.25C22.3211 24 24 22.3211 24 20.25V3.75C24 1.67893 22.3211 0 20.25 0Z"
        fill="#1877F2"
      />
      <path
        d="M18 12C18 8.7 15.3 6 12 6C8.7 6 6 8.7 6 12C6 15 8.175 17.475 11.025 17.925V13.725H9.525V12H11.025V10.65C11.025 9.15 11.925 8.325 13.275 8.325C13.95 8.325 14.625 8.475 14.625 8.475V9.975H13.875C13.125 9.975 12.9 10.425 12.9 10.875V12H14.55L14.25 13.725H12.825V18C15.825 17.55 18 15 18 12Z"
        fill="white"
      />
    </svg>
  );
}

function TwitterIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.25 0H3.75C1.67893 0 0 1.67893 0 3.75V20.25C0 22.3211 1.67893 24 3.75 24H20.25C22.3211 24 24 22.3211 24 20.25V3.75C24 1.67893 22.3211 0 20.25 0Z"
        fill="black"
      />
      <path
        d="M17.5 3H21L14 11.5L22 21H16L11 15.5L5.5 21H2L9.5 13L2 3H8L12.5 8.5L17.5 3ZM16 19.5H17.5L6.5 4.5H5L16 19.5Z"
        fill="white"
      />
    </svg>
  );
}

function WhatsappIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.75 0H4.25C2.17893 0 0.5 1.67893 0.5 3.75V20.25C0.5 22.3211 2.17893 24 4.25 24H20.75C22.8211 24 24.5 22.3211 24.5 20.25V3.75C24.5 1.67893 22.8211 0 20.75 0Z"
        fill="#25D366"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7 7.725C15.575 6.6 14.075 6 12.5 6C9.2 6 6.5 8.7 6.5 12C6.5 13.05 6.8 14.1 7.325 15L6.5 18L9.65001 17.175C10.55 17.625 11.525 17.925 12.5 17.925C15.8 17.925 18.5 15.225 18.5 11.925C18.5 10.35 17.825 8.85 16.7 7.725ZM12.5 16.95C11.6 16.95 10.7 16.725 9.95 16.275L9.8 16.2L7.925 16.725L8.45 14.925L8.3 14.7C7.775 13.875 7.55 12.975 7.55 12.075C7.55 9.375 9.8 7.125 12.5 7.125C13.85 7.125 15.05 7.65 16.025 8.55C17 9.525 17.45 10.725 17.45 12.075C17.45 14.7 15.275 16.95 12.5 16.95ZM15.2 13.2C15.05 13.125 14.3 12.75 14.15 12.75C14 12.675 13.925 12.675 13.85 12.825C13.775 12.975 13.475 13.275 13.4 13.425C13.325 13.5 13.25 13.5 13.1 13.5C12.95 13.425 12.5 13.275 11.9 12.75C11.45 12.375 11.15 11.85 11.075 11.7C11 11.55 11.075 11.475 11.15 11.4C11.225 11.325 11.3 11.25 11.375 11.175C11.45 11.1 11.45 11.025 11.525 10.95C11.6 10.875 11.525 10.8 11.525 10.725C11.525 10.65 11.225 9.9 11.075 9.6C11 9.375 10.85 9.375 10.775 9.375C10.7 9.375 10.625 9.375 10.475 9.375C10.4 9.375 10.25 9.375 10.1 9.525C9.94999 9.675 9.575 10.05 9.575 10.8C9.575 11.55 10.1 12.225 10.175 12.375C10.25 12.45 11.225 14.025 12.725 14.625C14 15.15 14.225 15 14.525 15C14.825 15 15.425 14.625 15.5 14.325C15.65 13.95 15.65 13.65 15.575 13.65C15.5 13.275 15.35 13.275 15.2 13.2Z"
        fill="white"
      />
    </svg>
  );
}

export function NativeShareButton(props: {
  onShare: (type: ShareType) => void;
  title: string;
  text: string;
  url: string;
}) {
  function handleClick() {
    props.onShare("native");

    // @ts-ignore
    navigator.share({
      title: props.title,
      text: props.text,
      url: props.url,
    });
  }

  return (
    <Button
      onClick={handleClick}
      sx={{
        backgroundColor: "#FFFFFF",
        color: memberTheme.palette.blue.main,
        borderColor: memberTheme.palette.greys.grey200,
        width: "100%",
        ":hover": {
          backgroundColor: darken("#FFFFFF", 0.1),
          color: memberTheme.palette.blue.main,
          borderColor: memberTheme.palette.greys.grey200,
        },
      }}
      variant="outlined"
    >
      <ShareIcon />
      <Typography fontWeight="bold" sx={{ paddingLeft: "10px", color: "inherit" }}>
        Other Sharing Options
      </Typography>
    </Button>
  );
}

export const FacebookShareButton = (props: { onShare: (type: ShareType) => void; url: string; text: string }) => {
  // NB: This share mechanism currently use the FB 'sharer.php' endpoint to get the details of teh share from the
  // 'og:title' meta tag attribute of the associated journey. It effectively ignores hte passed in 'text' string.
  // See the FB 'feed-dialog' endpoint for possible enhancements to this in the future.

  return (
    <Button
      onClick={() => props.onShare("facebook")}
      target="_blank"
      rel="noreferrer"
      href={`http://www.facebook.com/sharer/sharer.php?u=${props.url}`}
      variant="outlined"
      sx={{
        backgroundColor: "#FFFFFF",
        color: memberTheme.palette.blue.main,
        borderColor: memberTheme.palette.greys.grey300,
        height: "60px",
        width: "100%",
        ":hover": {
          backgroundColor: darken("#FFFFFF", 0.1),
          color: memberTheme.palette.blue.main,
          borderColor: memberTheme.palette.greys.grey300,
        },
      }}
    >
      <FacebookIcon />
      <Typography fontWeight="bold" sx={{ paddingLeft: "10px", color: "inherit" }}>
        Share on Facebook
      </Typography>
    </Button>
  );
};

export const TwitterShareButton = (props: { onShare: (type: ShareType) => void; url: string; text: string }) => {
  const encodedText = encodeURIComponent(props.text);
  return (
    <Button
      onClick={() => props.onShare("twitter")}
      target="_blank"
      rel="noreferrer"
      href={`http://twitter.com/intent/tweet?url=${props.url}&text=${encodedText}`}
      variant="outlined"
      sx={{
        backgroundColor: "#FFFFFF",
        color: memberTheme.palette.blue.main,
        borderColor: memberTheme.palette.greys.grey300,
        height: "60px",
        width: "100%",
        ":hover": {
          backgroundColor: darken("#FFFFFF", 0.1),
          color: memberTheme.palette.blue.main,
          borderColor: memberTheme.palette.greys.grey300,
        },
      }}
    >
      <TwitterIcon />
      <Typography fontWeight="bold" sx={{ paddingLeft: "10px", color: "inherit" }}>
        Share on X
      </Typography>
    </Button>
  );
};

export const WhatsappShareButton = (props: { onShare: (type: ShareType) => void; url: string; text: string }) => {
  const encodedText = encodeURIComponent(props.text);
  return (
    <Button
      onClick={() => props.onShare("whatsapp")}
      target="_blank"
      rel="noreferrer"
      href={`https://api.whatsapp.com/send?text=${encodedText}+${props.url}`}
      variant="outlined"
      sx={{
        backgroundColor: "#FFFFFF",
        color: memberTheme.palette.blue.main,
        borderColor: memberTheme.palette.greys.grey300,
        height: "60px",
        width: "100%",
        ":hover": {
          backgroundColor: darken("#FFFFFF", 0.1),
          color: memberTheme.palette.blue.main,
          borderColor: memberTheme.palette.greys.grey300,
        },
      }}
    >
      <WhatsappIcon />
      <Typography fontWeight="bold" sx={{ paddingLeft: "10px", color: "inherit" }}>
        Share on WhatsApp
      </Typography>
    </Button>
  );
};
